<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>Sarguja Division one day chess Tournament 2025</h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
  </div>
</section>
<section class="section-lg">
  <div class="container">
    <div class="sec-title">
      <h2><span>जी एच रायसोनी मेमोरियल सरगुजा संभाग स्तरीय रैपिड शतरंज प्रतियोगिता, दिनांक 24 अक्टूबर (शुक्रवार)</span>
      </h2>
    </div>

    <h5 class="fw-bold">स्थान – मानस भवन बैकुण्ठपुर जिला कोरिया</h5>

    <p>बैकुण्ठपुर– जी एच आर राय सोनी स्पोर्ट्स एण्ड कल्चरल फाउण्डेशन एवं कल्पना प्रकाश वेलफेयर फाउण्डेशन द्वारा
      प्रायोजित, छत्तीसगढ़ स्टेट चेस एसोसिएशन से मान्यता प्राप्त कोरिया जिला शतरंज संघ के तत्वावधान में 24 अक्टूबर को एक
      दिवसीय सरगुजा संभाग स्तरीय रैपिड शतरंज प्रतियोगिता का स्पर्धा का शुभारंभ नगर पालिका उपाध्यक्ष आशीष यादव आईसेक्ट
      कॉलेज के प्रबंधक नरेश सोनी, हॉसस्पिम के प्रविंद सिंह, अंतरराष्ट्रीय लेन हॉक खिलाड़ी सुमित्रा, प्राचार्य रजनी
      जायसवाल के आतिथ्य में तथा कोरिया जिला शतरंज संघ राजेंद्र सिंह के गरिमामयी उपस्थिति में सम्पन्न हुआ। उक्त स्पर्धा
      में ₹51,400 रूपये का नगद इनाम के अलावा मेडल, शील्ड और ट्रॉफी वितरित किया गया।</p>

    <p>पुरस्कार वितरण समापन समारोह में बैकुण्ठपुर विधानसभा के लोकप्रिय विधायक बैद्य लाल (पूर्व कैबिनेट मंत्री, छत्तीसगढ़
      शासन) के मुख्य आतिथ्य तथा नगर पालिका की अध्यक्ष श्रीमती नाविता शिवहरे के अध्यक्षता में सम्पन्न हुआ।</p>

    <p>इस अवसर पर छत्तीसगढ़ स्टेट चेस एसोसिएशन के ज्वाइंट सेक्रेटरी सरोज बैसवाल के साथ कोरिया जिला शतरंज संघ के अध्यक्ष
      राजेंद्र सिंह, आईसेक्ट कॉलेज के प्रबंधक नरेश सोनी, शगुफ्ता खानम के मंचासीन रही।</p>

    <p>स्पर्धा में संभाग के सभी जिले सरगुजा, बलरामपुर, कोरिया, मनेन्द्रगढ़, सूरजपुर एवं जशपुर के कुल 117 खिलाड़ियों ने
      हिस्सा लिया, जिसमें 19 खिलाड़ी अंतरराष्ट्रीय फिडे रेटिंग होल्डर थे। अंतरराष्ट्रीय स्विस लीग पद्धति से उक्त स्पर्धा
      8 चक्रों में सम्पन्न हुई। इस स्पर्धा में 6 वर्ष से लेकर 70 वर्ष आयु समूह के खिलाड़ियों ने हिस्सा लिया।</p>

    <p>अंत में मुख्य अतिथि महोदय के करकमलों से विजेता खिलाड़ियों को नगद पुरस्कार, मेडल, ट्रॉफी, शील्ड देकर सम्मानित किया
      गया।</p>
    <h5 class="fw-bold my-4">स्पर्धा के अंतिम परिणाम</h5>


    <div class="row row-cols-1 row-cols-md-2">
      <div class="col">
        <h6>ओपन वर्ग</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – सिद्धार्थ अम्बष्ट (सरगुजा) ₹10,000 नगद, ट्रॉफी</li>
          <li>दूसरा – अजय कुमार गुप्ता (कोरिया) ₹6,000 नगद, ट्रॉफी</li>
          <li>तीसरा – परवेज अंसारी (कोरिया) ₹3,500 नगद, ट्रॉफी</li>
          <li>चौथा – हसनैन अली (कोरिया) ₹2,100 नगद</li>
          <li>पांचवां – गौतम केशरी (सरगुजा) ₹1,500 नगद</li>
          <li>छठवां – शिवहरी (कोरिया) ₹1,000 नगद</li>
          <li>सातवां – अभिषेक राजवाड़े (सूरजपुर) ₹700 नगद</li>
          <li>आठवां – राशिद रशीद (कोरिया) ₹600 नगद</li>
          <li>नौवां – अनीश अंसारी (सरगुजा) ₹500 नगद</li>
          <li>दसवां – उदित नारायण चक्रधारी (कोरिया) ₹500 नगद</li>
        </ul>
        <h6>अंडर 17 बालक वर्ग</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – यीशांश गुप्ता (सरगुजा) ₹2,100 नगद, ट्रॉफी</li>
          <li>दूसरा – यश कुमार गुप्ता (सरगुजा) ₹1,500 नगद, ट्रॉफी</li>
          <li>तीसरा – रोहन गुप्ता (सरगुजा) ₹1,100 नगद, ट्रॉफी</li>
          <li>चौथा – वरुण सोनी (सरगुजा) ₹800 नगद</li>
        </ul>
        <h6>अंडर 17 बालिका वर्ग</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – फरहीन खान (कोरिया) ₹2100 नगद, ट्रॉफी</li>
          <li>दूसरा – मेधांशी टिकरी (सरगुजा) ₹1500 नगद, ट्रॉफी</li>
          <li>तीसरा – सुरभि राय (सरगुजा) ₹1100 नगद, ट्रॉफी</li>
          <li>चौथा – स्नेहा गुप्ता (सरगुजा) ₹800 नगद</li>
        </ul>
          <h6>अंडर 13 बालक वर्ग</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – अंशुमन सहाय (सरगुजा) ₹2100 नगद, ट्रॉफी</li>
          <li>दूसरा – हिमानिश टिकरी (सरगुजा) ₹1500 नगद, ट्रॉफी</li>
          <li>तीसरा – हर्षित गुप्ता (कोरिया) ₹1100 नगद, ट्रॉफी</li>
          <li>चौथा – विशेष जे एस राजवाड़े (सूरजपुर) ₹800 नगद</li>
        </ul>
      </div>
      <div class="col">

        <h6>अंडर 13 बालिका वर्ग</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – नय्या सिंह (बलरामपुर) ₹2100 नगद, ट्रॉफी</li>
          <li>दूसरा – अनन्या राय (सूरजपुर) ₹1500 नगद, ट्रॉफी</li>
          <li>तीसरा – वैदिका शर्मा (कोरिया) ₹1100 नगद, ट्रॉफी</li>
          <li>चौथा – आयशा बानों (एम सी बी) ₹800 नगद</li>
        </ul>
        <h6>अंडर 9 बालक वर्ग</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – अखत राज डांगरे (सरगुजा) ट्रॉफी</li>
          <li>दूसरा – अक्षत पाठक (कोरिया) ट्रॉफी</li>
          <li>तीसरा – आरव पाण्डेय (सरगुजा) ट्रॉफी</li>
        </ul>
        <h6>अंडर 9 बालिका वर्ग</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – अंशा फातिमा (कोरिया) ट्रॉफी</li>
        </ul>
        <h6>अंडर 7 बालक वर्ग</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – अहान गुप्ता (कोरिया) ट्रॉफी</li>
          <li>दूसरा – वेदान्त चौरसिया (सूरजपुर) ट्रॉफी</li>
        </ul>
        <h6>बेस्ट वेटरन</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – देवेंद्र कुमार (कोरिया) ₹1000 नगद, ट्रॉफी</li>
          <li>दूसरा – राजेश कुमार मिश्रा (एम.सी.बी.) ₹500 नगद, ट्रॉफी</li>
        </ul>
        <h6>बेस्ट महिला</h6>
        <ul class="list-style list-style1 mb-3">
          <li>प्रथम – कशिश सिन्हा (सरगुजा) ₹1000 नगद, ट्रॉफी</li>
          <li>दूसरा – सृष्टि राय (सरगुजा) ₹500 नगद, ट्रॉफी</li>
        </ul>
      </div>
    </div>
    <p>टूर्नामेंट को सफल करने में चीफ आर्बिटर शेष रतन जायसवाल के साथ अंजुम, रविशंकर, योगेश गुप्ता, वी मनियन, सुनीता
      राजवाड़े, कोरिया शतरंज संघ के टूर्नामेंट डायरेक्टर अब्दुल शमीम, शगुफ्ता खानम, आशीष गुप्ता, सर्वेश कुमार रूप, आनंद
      कुमार तिवारी, असगर इमाम, परवेज अंसारी की सक्रिय भूमिका रही। संपूर्ण स्पर्धा का संचालन कोरिया शतरंज संघ के योगेश
      गुप्ता ने किया।</p>

  </div>
</section>
<section class="section-lg pt-0">
  <div class="container">
    <hr class="mb-5">
    <div class="sec-title mt-4 text-center">
      <h2><span>Photo Gallery</span></h2>
    </div>
    <div class="lightBox--gallery">
      <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess1.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess1.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess1.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess2.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess2.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess2.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess3.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess3.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess3.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess4.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess4.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess4.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess5.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess5.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess5.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>
      </ul>
    </div>
    <hr class="my-5">
    <div class="sec-title mt-4 text-center">
      <h2><span>Media Coverage</span></h2>
    </div>
    <div class="lightBox--gallery">
      <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>
        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media1.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media1.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media1.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>

        <li class="col"
          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media2.webp"
          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media2.webp">
          <a href="Javascript:void(0);">
            <img
              src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess-media2.webp"
              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
            <div class="light-gallery-poster">
              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
            </div>
          </a>
        </li>

      </ul>
    </div>
  </div>
</section>
